import { request } from '@/api/client';
import { Device } from '@/classes/Device';
import { UnauthorizedError } from '@/classes/Error';
import { API_URL } from '@/constants';
import { RemoteConnectPayload } from '@/types';
import { parse, stringify } from 'qs';

export async function getAccessToken(): Promise<string | null> {
  try {
    const data = await request<{ accessToken: string }>({
      url: `${API_URL}/api/auth/access-token`,
      init: { method: 'POST', credentials: 'include' },
    });

    return data?.accessToken ?? null;
  } catch (e) {
    if (e instanceof UnauthorizedError) {
      return null;
    }

    throw e;
  }
}

export async function logout(): Promise<void> {
  await fetch(`${API_URL}/api/auth/logout`, {
    method: 'POST',
    credentials: 'include',
  });
}

export async function registerRemoteConnect(): Promise<RemoteConnectPayload> {
  const response = await fetch(`${API_URL}/api/auth/remote/connect/pid/register`, {
    method: 'POST',
    credentials: 'include',
  });
  const payload = await response.json();

  if (payload.url) {
    const [url, query] = payload.url.split('?');
    const params = parse(query);

    if (Device.isWebOS) {
      params.utm_source = 'bbsworld.lg';
      params.utm_medium = 'webos';
      params.utm_campaign = 'login';
    } else if (Device.isTizen) {
      params.utm_source = 'bbsworld.samsung';
      params.utm_medium = 'tizenos';
      params.utm_campaign = 'login';
    } else {
      params.utm_source = 'bbsworld.web';
      params.utm_medium = 'web';
      params.utm_campaign = 'login';
    }

    payload.url = `${url}?${stringify(params)}`;
  }

  return payload;
}

export async function fetchRemoteConnect(remoteUUID: string): Promise<boolean> {
  const response = await fetch(`${API_URL}/api/auth/remote/connect/pid/callback?${stringify({ remoteUUID })}`, {
    credentials: 'include',
  });

  if (response.status === 200) {
    return true;
  } else {
    return false;
  }
}
